import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './layouts/AppLayout';
import { Dashboard } from './pages/Dashboard';
import { RFIs } from './pages/RFIs';
import { Deliveries } from './pages/Deliveries';
import { Placeholder } from './pages/Placeholder';
import { DemoPage } from './pages/DemoPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="demo" element={<DemoPage />} />
          <Route path="rfis" element={<RFIs />} />
          <Route path="deliveries" element={<Deliveries />} />
          <Route path="tasks" element={<Placeholder title="Site Tasks" />} />
          <Route path="subcontractors" element={<Placeholder title="Subcontractors" />} />
          <Route path="safety" element={<Placeholder title="Safety Command" />} />
          <Route path="reports" element={<Placeholder title="Progress Reports" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;